module.exports = __webpack_public_path__ + "static/media/socialResponsibilityIcon.9d46e1f2.svg";